import _implicitStylesheets from "./error.css";
import _implicitScopedStylesheets from "./error.scoped.css?scoped=true";
import _pageHeaderContainer from "page/headerContainer";
import _c360Button from "c360/button";
import _pageFooterContainer from "page/footerContainer";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<img${"a0:src"} class="error-bird${0}"${"a0:alt"}${2}>`;
const $fragment2 = parseFragment`<div class="container-text${0}"${2}><h1 class="title${0}"${2}>${"t2"}</h1><p class="description${0}"${2}>${"t4"}</p></div>`;
const stc0 = {
  key: 0
};
const stc1 = {
  classMap: {
    "container-inner": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "container-buttons": true
  },
  key: 6
};
const stc3 = {
  "small-button": true
};
const stc4 = {
  key: 9
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, sp: api_static_part, st: api_static_fragment, d: api_dynamic_text, b: api_bind, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_custom_element("page-header-container", _pageHeaderContainer, stc0), api_element("div", stc1, [api_static_fragment($fragment1, 3, [api_static_part(0, {
    attrs: {
      "src": $cmp.images.errorBird,
      "alt": $cmp.sharedLabels.decorativeImage
    }
  }, null)]), api_static_fragment($fragment2, 5, [api_static_part(2, null, api_dynamic_text($cmp.labels.title)), api_static_part(4, null, api_dynamic_text($cmp.labels.description))]), api_element("div", stc2, [api_custom_element("c360-button", _c360Button, {
    classMap: stc3,
    props: {
      "label": $cmp.labels.supportButtonLabel,
      "variant": "neutral"
    },
    key: 7,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleSupport))
    }
  }), api_custom_element("c360-button", _c360Button, {
    classMap: stc3,
    props: {
      "label": $cmp.labels.backButtonLabel,
      "variant": "brand"
    },
    key: 8,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleBack))
    }
  })])]), api_custom_element("page-footer-container", _pageFooterContainer, stc4)];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-30t356jiqkq";
tmpl.legacyStylesheetToken = "pages-error_error";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
